import { Box } from "@chakra-ui/react";
import { BorderLeft } from "@mui/icons-material";

const FindSuppliers = () => {
  const styles = {
    container: {
      padding: "20px",
      fontFamily: "Arial, sans-serif",
    },
    mainContent: {
      flex: 1,
      paddingLeft: "20px",
    },
    supplierGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "20px",
      width: "100%",
    },
    navigation: {
      display: "flex",
      borderBottom: "1px solid #e0e0e0",
      marginBottom: "24px",
    },
    navItem: {
      padding: "12px 24px",
      color: "#666",
      cursor: "pointer",
      fontSize: "14px",
    },
    activeNavItem: {
      color: "#000",
      borderBottom: "2px solid #000",
    },
    sidebar: {
      width: "200px",
      padding: "16px",
    },
    filterSection: {
      marginBottom: "20px",
    },
    filterHeader: {
      fontSize: "14px",
      fontWeight: "bold",
      marginBottom: "12px",
    },
    checkbox: {
      marginRight: "8px",
    },
    checkboxLabel: {
      fontSize: "14px",
      color: "#333",
    },
    supplierSection: {
      marginBottom: "32px",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "16px",
    },
    supplierCard: {
      border: "1px solid #e0e0e0",
      borderRadius: "4px",
      padding: "16px",
      marginBottom: "16px",
      backgroundColor: "white",
    },
    logo: {
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      backgroundColor: "#f0f0f0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "12px",
      fontSize: "12px",
    },
    header: {
      display: "flex",
      alignItems: "center",
      marginBottom: "12px",
    },
    companyName: {
      fontSize: "16px",
      fontWeight: "bold",
      marginRight: "12px",
    },
    viewButton: {
      backgroundColor: "#666",
      color: "white",
      border: "none",
      borderRadius: "4px",
      padding: "6px 12px",
      fontSize: "12px",
      cursor: "pointer",
    },
    categoryTag: {
      backgroundColor: "#f5f5f5",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      marginRight: "8px",
    },
    locatonTag: {
      BorderLeft: "1px solid grey",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      marginleft: "8px",
    },
    productsSection: {
      marginTop: "12px",
    },
    productCount: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "8px",
    },
    productList: {
      fontSize: "14px",
      color: "#333",
    },
  };

  const navItems = [
    "Client Background",
    "Objectives Dashboard",
    "Segment Risks",
    "Segment Analysis",
    "Competitive Risks",
    "Find Suppliers",
  ];

  const nearbySuppliers = [
    {
      name: "PQR Nunc Eu Varius Orci Corp",
      logo: "DEF",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: ["Caustic Soda, Sodium Hydroxide"],
      productCount: 1,
    },
    {
      name: "Chemical Solutions Ltd",
      logo: "CSL",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: [
        "Antimony Oxide",
        "Sal Soda (Washing Soda), Sodium Carbonate (Hydrated)",
      ],
      productCount: 2,
    },
    {
      name: "EcoTech Chemicals Inc",
      logo: "ECO",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: [
        "Antimony Oxide",
        "Sal Soda (Washing Soda), Sodium Carbonate (Hydrated)",
      ],
      productCount: 2,
    },
  ];

  const discoverSuppliers = [
    {
      name: "PQR Nunc Eu Varius Orci Corp",
      logo: "DEF",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: ["Industrial Grade Chemicals"],
      productCount: 1,
    },
    {
      name: "Green Chemical Solutions",
      logo: "GCS",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: ["Eco-friendly Chemical Products"],
      productCount: 1,
    },
    {
      name: "Allied Chemicals Corp",
      logo: "ACC",
      representative: "Sanjay Kapoor",
      role: "CEO & Green Tech Enthusiast",
      category: "Chemicals And Allied Products",
      location: "Karnataka",
      products: ["Specialty Chemical Solutions"],
      productCount: 1,
    },
  ];

  const SupplierCard = ({ supplier }) => (
    <div style={styles.supplierCard}>
      <div style={styles.header}>
        <div style={styles.logo}>{supplier.logo}</div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={styles.companyName}>{supplier.name}</span>
            <button style={styles.viewButton}>View SME Profile</button>
          </div>
          <div>
            {supplier.representative}, {supplier.role}
          </div>
        </div>
      </div>
      <div>
        <span style={styles.categoryTag}>{supplier.category}</span>
        <span style={styles.locatonTag}>{supplier.location}</span>
      </div>
      <div style={styles.productsSection}>
        <div style={styles.productCount}>
          Products Available {supplier.productCount} product
          {supplier.productCount > 1 ? "s" : ""} found
        </div>
        <div style={styles.productList}>{supplier.products.join(", ")}</div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={{ display: "flex" }}>
        <main style={styles.mainContent}>
          <section style={styles.supplierSection}>
            <h2 style={styles.sectionTitle}>SUPPLIERS NEAR YOU</h2>
            <div style={styles.supplierGrid}>
              {nearbySuppliers.map((supplier, index) => (
                <SupplierCard key={index} supplier={supplier} />
              ))}
            </div>
          </section>

          <section style={styles.supplierSection}>
            <h2 style={styles.sectionTitle}>DISCOVER NEW</h2>
            <div style={styles.supplierGrid}>
              {discoverSuppliers.map((supplier, index) => (
                <SupplierCard key={index} supplier={supplier} />
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};


export default FindSuppliers;
